var map = {
	"./007-microphone-1.png": 505,
	"./010-home.png": 506,
	"./013-document-1.png": 507,
	"./014-document.png": 508,
	"./015-color-palette.png": 509,
	"./017-video-camera.png": 510,
	"./024-like.svg": 755,
	"./1.svg": 878,
	"./155-credit-card.svg": 756,
	"./2.svg": 879,
	"./3.svg": 880,
	"./4.svg": 881,
	"./New Customer.svg": 882,
	"./NotOpen.svg": 883,
	"./Opened.svg": 884,
	"./Profit.svg": 885,
	"./SalesRevenue.svg": 886,
	"./Sent.svg": 887,
	"./Slack.svg": 888,
	"./address.svg": 757,
	"./adobe.svg": 889,
	"./arrow-left.svg": 628,
	"./arrow-right.svg": 629,
	"./book.svg": 890,
	"./camera.svg": 891,
	"./chat.svg": 703,
	"./clipboard.svg": 892,
	"./cloud.svg": 893,
	"./columns.svg": 894,
	"./documentation.svg": 704,
	"./file.svg": 895,
	"./flat.svg": 896,
	"./headphone.svg": 897,
	"./iconfinder_trello_2317760.svg": 898,
	"./idea.svg": 705,
	"./image.png": 442,
	"./image.svg": 899,
	"./label.png": 511,
	"./layers.svg": 900,
	"./left.svg": 901,
	"./logo2.svg": 902,
	"./logo3.svg": 903,
	"./logo4.svg": 904,
	"./logo5.svg": 905,
	"./logo6.svg": 906,
	"./logoIn.svg": 907,
	"./paint.svg": 908,
	"./protection.svg": 909,
	"./quote.png": 446,
	"./repeat.svg": 910,
	"./right.svg": 682,
	"./strategy.svg": 911,
	"./theme.svg": 912,
	"./user.svg": 758,
	"./water-fall.svg": 913
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 877;